import {SCRIPT_PREVENTION} from '@/util/contents/contact-us';
import {check, type FormValues, type Rule} from '@/util/validation';

/** True when the text contains a blocked keyword (script tags, links). Empty text is allowed. */
export const containsScript = (value: string | undefined): boolean => {
    const data = value?.replace(/\s+/g, ' ').trim();
    return !(data === undefined || data.trim() === '' || !SCRIPT_PREVENTION.some((keyword) => data.toLowerCase().includes(keyword)));
};

/** Validation rule that rejects text containing a blocked keyword. */
export const testScript = <V extends FormValues>(message: string): Rule<V> => check<V>((value) => !containsScript(value), message);
